import { Component, TemplateRef } from '@angular/core';
import { NavigationService } from 'app/utils/navigation/navigation.service';
import { MetaTagsHelper } from 'app/utils/metaTags/metaTagsHelper';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    moduleId: module.id,
    selector: 'onlineinsurance',
    templateUrl: './onlineinsurance.component.html',
    styleUrls: ['./onlineinsurance.component.less'],
})
export class OnlineInsuranceComponent {
    bsModalRef: BsModalRef;
    activeSlide = 1;
    constructor(public navigationService: NavigationService, private metaTagsHelper: MetaTagsHelper, private modalService: BsModalService) {
        this.metaTagsHelper.setTitleAndMetaTags('META.ONLINE_INSURANCE');
    }

    setActiveSlide(slideNo: number) {
        this.activeSlide = slideNo;
    }

    openModal(template: TemplateRef<any>) {
        this.bsModalRef = this.modalService.show(template);
    }
}
